import { useTranslation } from 'react-i18next';
import { Notice } from '@anytag/shared-atoms';
import { InfluencerWhitelist } from '@anytag/graphql';
import { ListWithPagination } from '@anytag/shared-molecules';
import {
  MarketplaceInfluencersSort,
  MarketplaceInfluencersList,
  MarketplaceInfluencersFilter
} from '@anytag/shared-organisms';
import { useMarketplaceInfluencersList } from '../hooks';
import { useMarketplaceDetailsContext } from '../../marketplace-details-context';
import { useToggleSelectedInfluencers } from './hooks';

export interface MarketplaceInfluencersForOtherUsersProps {
  influencerWhitelist: InfluencerWhitelist;
}

export const MarketplaceInfluencersForOtherUsers = ({
  influencerWhitelist
}: MarketplaceInfluencersForOtherUsersProps) => {
  const { t } = useTranslation();
  const { marketplace } = useMarketplaceDetailsContext();
  const { fetchingInfluencersList, listInfluencers, totalRecords } = useMarketplaceInfluencersList();
  const { AddAllInfluencersModal, RemoveAllInfluencersModal, sortSelectButtonProps, generateListSelectButtonProps } =
    useToggleSelectedInfluencers({ totalRecords, listInfluencers, influencerWhitelist });

  return (
    <>
      <ListWithPagination pagination={{ totalRecords }}>
        <Notice type="info" title={t('Information')} description={t('Influencer.SelectInfluencerHelp')} />

        <MarketplaceInfluencersFilter marketplace={marketplace} />
        <MarketplaceInfluencersSort selectButtonProps={sortSelectButtonProps} />

        <MarketplaceInfluencersList
          data={listInfluencers}
          totalRecords={totalRecords}
          loading={fetchingInfluencersList}
          generateSelectButtonProps={generateListSelectButtonProps}
        />
      </ListWithPagination>

      {AddAllInfluencersModal}
      {RemoveAllInfluencersModal}
    </>
  );
};
